import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_2.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/aziro');
  const shareText = encodeURIComponent('Aziro: Where innovation drives a people-first workplace!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>aziro Technology Solutions — Outstanding Workplaces</title>
        <meta property="og:title" content="aziro Technology Solutions — Outstanding Workplaces" />
        <meta property="og:description" content=" Aziro: Where innovation drives a people-first workplace" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777881438/i_2_aquhxc.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/aziro" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="aziro Technology Solutions — Outstanding Workplaces" />
        <meta name="twitter:description" content="Aziro: Where innovation drives a people-first workplace" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777881438/i_2_aquhxc.jpg" />
      </Helmet>

      <div className="sight_2_page_wrapper">
      <div className="sight_2_content_container">

        <div className="sight_2_section_one">

          {/* TITLE */}
          <h1 className="sight_2_page_title">
            Aziro: Where innovation drives a people-first workplace
          </h1>

          {/* ROW */}
          <div className="sight_2_row">

            {/* LEFT SIDE */}
            <div className="sight_2_left">
              <div className="sight_2_image_wrapper">
                <img src="/assets/i_2.jpg" alt="Team meeting discussion" className="sight_2_blog_image" />
                <img src="/assets/bg_1.png" className="sight_2_left_badge" />
              </div>
                {/* SHARE SECTION */}
                <div className="sight_2_share_section">
                  <span className="sight_2_share_text">Share :</span>
                  <div className="sight_2_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_2_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_2_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_2_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_2_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

               <p className="sight_2_intro_paragraph">
                At Outstanding Workplaces, we believe exceptional workplaces thrive where innovation, leadership, and employee experience intersect. Through our certification journey, we partner with organizations to uncover and celebrate the practices that define their culture and shape how employees experience work every day.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_2_right">
              <div className="sight_2_ad_card">
                <img src="/assets/bc_1.png" className="sight_2_ad_bg" />
                <div className="sight_2_ad_overlay"></div>
                <img src="/assets/bg_1.png" className="sight_2_ad_badge" />
                <div className="sight_2_ad_content">
                  <h2>Earn the Outstanding <br /><span>Workplaces Certification</span></h2>
                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>
                  <button 
  className="sight_2_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>

        </div>

        {/* ====== SECTION TWO (UNCHANGED) ====== */}
        <div className="sight_2_section">

          <ul className="sight_2_intro_list">
            <li>Aziro (formerly MSys Technologies) exemplifies this approach. As an AI-native product engineering company, Aziro drives innovation-led technology transformation for Fortune 500 and Global 2000 enterprises, as well as ISVs, combining cutting-edge solutions with a people-focused culture.</li>
          </ul>

          <div className="sight_2_topics">

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Prioritize Employee Wellbeing</h2>
              <ul className="sight_2_topic_list">
                <li>Great workplaces recognize that happy, healthy employees are more productive. Aziro emphasizes holistic wellbeing programs, from mental health support to flexible work arrangements, creating a culture where people thrive.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Foster Transparent Communication</h2>
              <ul className="sight_2_topic_list">
                <li>Open, honest communication builds trust. Outstanding Workplaces encourages organizations to implement clear feedback channels, town halls, and cross-team updates to keep everyone aligned.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">⁠Encourage Continuous Learning</h2>
              <ul className="sight_2_topic_list">
                <li>Upskilling drives engagement and innovation. Aziro invests in employee learning, certifications, and internal knowledge sharing to keep teams future-ready.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">⁠Promote Inclusive Leadership</h2>
              <ul className="sight_2_topic_list">
                <li>Leaders shape culture. Effective leaders at Aziro and other certified organizations actively practice inclusion, mentorship, and recognition, empowering all employees to contribute meaningfully.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Recognize and Reward Contributions</h2>
              <ul className="sight_2_topic_list">
                <li>Acknowledging effort motivates employees. Implement structured recognition programs and celebrate successes big and small, reinforcing positive behaviors.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Embrace Innovation and Experimentation</h2>
              <ul className="sight_2_topic_list">
                <li>Aziro thrives on innovation-led tech transformation. Organizations that encourage creative problem-solving, experimentation, and safe failure cultivate high-performing, agile cultures.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Define Clear Goals and Expectations</h2>
              <ul className="sight_2_topic_list">
                <li>Clarity reduces confusion and enhances accountability. Establish transparent objectives, key results (OKRs), and performance metrics that align individual contributions with organizational goals.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Enable Work-Life Flexibility</h2>
              <ul className="sight_2_topic_list">
                <li>Flexible work models improve satisfaction and retention. Certified workplaces understand that balance leads to happier employees and better business outcomes.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">Measure and Improve Employee Experience</h2>
              <ul className="sight_2_topic_list">
                <li>Data-driven insights guide culture improvements. Conduct regular engagement surveys, pulse checks, and feedback loops to continuously enhance the employee experience.</li>
              </ul>
            </div>

            <div className="sight_2_topic_item">
              <h2 className="sight_2_topic_heading">⁠Build a Purpose-Driven Culture</h2>
              <ul className="sight_2_topic_list">
                <li>Employees engage deeply when work aligns with purpose. Aziro and other top workplaces integrate mission-driven initiatives, sustainability, and social responsibility into everyday work.</li>
              </ul>
            </div>

          </div>
        </div>

        {/* ====== END SECTION TWO ====== */}

       </div>
   </div>
    </>
  );
}


export default BlogPage;


